import { useState } from 'react';
import { studentAPI } from '../../utils/api';

const GoalSetter = ({ current, onUpdated }) => {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(current || 5);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await studentAPI.setGoal(target);
      onUpdated(target);
      setOpen(false);
    } catch {
      // fail silently
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <span
        onClick={() => setOpen(true)}
        style={{ fontSize: '9px', fontWeight: 700, color: 'rgba(255,255,255,0.5)', cursor: 'pointer', textDecoration: 'underline', textUnderlineOffset: '2px' }}
      >
        Change
      </span>

      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setOpen(false)}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '24px', width: '300px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}
            onClick={e => e.stopPropagation()}>

            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--text)', marginBottom: '6px' }}>🎯 Set Daily Goal</div>
            <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '20px' }}>How many topics do you want to study today?</div>

            {/* Number picker */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '24px' }}>
              <button
                onClick={() => setTarget(t => Math.max(1, t - 1))}
                style={{ width: '40px', height: '40px', borderRadius: '50%', border: '2px solid var(--border)', background: 'var(--bg)', fontSize: '20px', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text)' }}
              >−</button>

              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', fontWeight: 800, color: 'var(--brand-primary)', lineHeight: 1 }}>{target}</div>
                <div style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>topics</div>
              </div>

              <button
                onClick={() => setTarget(t => Math.min(20, t + 1))}
                style={{ width: '40px', height: '40px', borderRadius: '50%', border: '2px solid var(--border)', background: 'var(--bg)', fontSize: '20px', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text)' }}
              >+</button>
            </div>

            {/* Quick presets */}
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '20px' }}>
              {[3, 5, 7, 10].map(n => (
                <button key={n} onClick={() => setTarget(n)}
                  style={{ padding: '5px 12px', borderRadius: '20px', border: `1.5px solid ${target === n ? 'var(--brand-primary)' : 'var(--border)'}`, background: target === n ? 'var(--brand-primary-light)' : 'white', color: target === n ? 'var(--brand-primary)' : 'var(--muted)', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>
                  {n}
                </button>
              ))}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <button onClick={() => setOpen(false)}
                style={{ padding: '10px', borderRadius: '10px', border: '1.5px solid var(--border)', background: 'white', fontSize: '13px', fontWeight: 700, cursor: 'pointer', color: 'var(--muted)' }}>
                Cancel
              </button>
              <button onClick={handleSave} disabled={saving}
                style={{ padding: '10px', borderRadius: '10px', border: 'none', background: 'var(--brand-primary)', color: 'white', fontSize: '13px', fontWeight: 800, cursor: 'pointer' }}>
                {saving ? 'Saving...' : 'Save Goal'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GoalSetter;
